import React, { useEffect, useState } from 'react';
import { ACTIVITY_LOG_EVENT_TYPE, SESSION_TIER1USER, ACTIVITY_LOG_SELECT_MAP, ACTIVITY_LOG_SELECT_MAP_LENGTH, ACTIVITY_LOG_SELECT_MAP_REVERSED, ACTIVITY_LOG_USER_EVENT_MAP, ACTIVITY_LOG_USER_EVENT_MAP_LENGTH, ACTIVITY_LOG_USER_EVENT_MAP_REVERSED, SESSION } from '../../shared/Constants';
import Input from "../../UI/Input/Input";

const EventBlock = (props) => {
    let sfullEvents;
    const [formInputElements, setFormInputElements] = useState({
        eventType:{
            elementType: 'select',
            elementConfig: {
                type: 'text',
                id: 'eventType',
                placeholder: '',
                options: ACTIVITY_LOG_EVENT_TYPE.map(
                    (activity) => ({
                        "disabled": false,
                        "value": activity,
                        "displayValue": activity
                    })
                )
            },
            value: props.eventTypeValue,
            validation: {
                required: false
            },
            valid: true,
            touched: false,
            label: "Event Type",
            inputType: "Quarter"
        },
        event:{
            elementType: 'select',
            elementConfig: {
                type: 'text',
                id: 'event',
                placeholder: '',
                options: []
            },
            value: 'Select One',
            validation: {
                required: false
            },
            valid: true,
            touched: false,
            label: "Event",
            inputType: "Half"
        }
    })

    const initialiseForm = (sfullEvents) => {
        let updatedForm = {...formInputElements};
        let updatedEventElement = {...updatedForm['event']}
        if(props.searchState !== null && props.searchState.event !== ''){
            updatedEventElement.value = ACTIVITY_LOG_SELECT_MAP_REVERSED[props.searchState.event]?ACTIVITY_LOG_SELECT_MAP_REVERSED[props.searchState.event].name:ACTIVITY_LOG_USER_EVENT_MAP_REVERSED[props.searchState.event].name
        }
        updatedEventElement.elementConfig.options = sfullEvents

        updatedForm['event'] = updatedEventElement

        updatedForm['eventType'].value = props.eventTypeValue ?? 'Select One'
        updatedForm['eventType'].touched = false
        updatedForm['eventType'].valid = true
        setFormInputElements(updatedForm)
    }

    const constructEventList = () => {
        if((props.eventTypeValue === 'Select One' || props.eventTypeValue === 'ALL') && !props.flagUserActivity){
            sfullEvents = Object.keys(ACTIVITY_LOG_SELECT_MAP).map(
                (activity) => ({
                    "disabled": false,
                    "value": activity,
                    "displayValue": activity
                })
            )
            let temp = Object.values(ACTIVITY_LOG_USER_EVENT_MAP).filter(val => val.name !== 'Select One')
            let tempEvents = temp.map(
                activity => ({
                    "disabled": activity.disabled,
                    "value": activity.name,
                    "displayValue": activity.name
                })
            )
            sfullEvents = sfullEvents.concat(tempEvents)
            if(formInputElements.event.elementConfig.options.length !== (ACTIVITY_LOG_SELECT_MAP_LENGTH + ACTIVITY_LOG_USER_EVENT_MAP_LENGTH) - 1){
                initialiseForm(sfullEvents)
            }
        }else if(props.eventTypeValue === 'AGENT' || props.flagUserActivity){
            sfullEvents = Object.keys(ACTIVITY_LOG_SELECT_MAP).map(
                (activity) => ({
                    "disabled": false,
                    "value": activity,
                    "displayValue": activity
                })
            )
            if(formInputElements.event.elementConfig.options.length !== ACTIVITY_LOG_SELECT_MAP_LENGTH){
                initialiseForm(sfullEvents)
            }
        }else{
            sfullEvents = Object.values(ACTIVITY_LOG_USER_EVENT_MAP).map(
                activity => ({
                    "disabled": activity.disabled,
                    "value": activity.name,
                    "displayValue": activity.name
                })
            )
            if(formInputElements.event.elementConfig.options.length !== ACTIVITY_LOG_USER_EVENT_MAP_LENGTH){
                initialiseForm(sfullEvents)
            }
        }
        if(props.eventList.length === 0 || props.eventList.length !== sfullEvents.length)props.setEventList(sfullEvents)
    }

    useEffect(() => {
        props.clearSearch.current = clearEvent
        constructEventList()
    },[props.eventList, props.eventTypeValue])

    const clearEvent = () => {
        const updatedForm = {...formInputElements}

        updatedForm['event'].value = 'Select One'
        updatedForm['event'].touched = false
        updatedForm['event'].valid = true

        updatedForm['eventType'].value = props.userType === SESSION_TIER1USER ? 'USER' : 'Select One';
        updatedForm['eventType'].touched = false
        updatedForm['eventType'].valid = true

        setFormInputElements(updatedForm)
    }
    

    const inputChangedHandler = (eventReceived, formIdentifier) => {
        let updatedForm = {...formInputElements};

        const updatedFormElement = { ...updatedForm[formIdentifier] };
        updatedFormElement.valid = true;
        props.errorHandler(null);

        if(formIdentifier === 'event'){
            if(ACTIVITY_LOG_SELECT_MAP[eventReceived.target.value]){
                const val = ACTIVITY_LOG_SELECT_MAP[eventReceived.target.value]
                props.setEvent(val.name)
                updatedFormElement.value = val.name
            }
            else {
                updatedFormElement.value = eventReceived.target.value
                props.setEvent(eventReceived.target.value)
            }
            props.setEventStatus('Select One');
        }else{
            updatedFormElement.value = eventReceived.target.value
            props.setEventList([])
            if(eventReceived.target.value === "USER" || eventReceived.target.value === "ALL") {
                props.setAgentIdDisabled(true)
                props.setEvent('Select One')
                props.setEventStatus('Select One')
            }
            else if(eventReceived.target.value !== "USER" && eventReceived.target.value !== "ALL" && props.agentIdDisabled){
                props.setAgentIdDisabled(false);
            }
            if(eventReceived.target.value === 'AGENT'){
                props.setEvent('Select One')
                props.setEventStatus('Select One')
            }
            props.setEventType(eventReceived.target.value)
        }
        updatedFormElement.touched = true
        updatedForm[formIdentifier] = updatedFormElement
        setFormInputElements(updatedForm)
    }

    const createFormWhenUserEventIsDisabled = () => {
        const formElement = formInputElements['event']

        return(
            <>
                <div style={{"display":"flex"}}>
                    <Input
                        key={formElement.elementConfig.id}
                        elementType={formElement.elementType}
                        elementConfig={formElement.elementConfig}
                        value={formElement.value}
                        invalid={!formElement.valid}
                        shouldValidate={formElement.validation}
                        touched={formElement.touched}
                        label={formElement.label}
                        changed={(event) => inputChangedHandler(event, formElement.elementConfig.id)}
                        extendedInput={formElement.extendedInput}
                        inputType={formElement.inputType} 
                    />
                </div>
            </>
        )
    }

    const createFormWhenUserEventIsNotDisabled = () => {
        const formsElementsArray =[];

        for(let key in formInputElements) {
            formsElementsArray.push({
                id: key,
                config: formInputElements[key]
            });
        }

        
        return (
        <>
            <div style={{"display":"flex"}}>
                {formsElementsArray.map((formElement => (
                    <Input
                        key={formElement.id}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={formElement.config.value}
                        invalid={!formElement.config.valid}
                        shouldValidate={formElement.config.validation}
                        touched={formElement.config.touched}
                        label={formElement.config.label}
                        changed={(event) => inputChangedHandler(event, formElement.id)}
                        extendedInput={formElement.config.extendedInput}
                        inputType={formElement.config.inputType}
                    />
                )))}
            </div>
        </>
        )
    }

    const createForm = () => {
        if(props.flagUserActivity)return createFormWhenUserEventIsDisabled()
        else return createFormWhenUserEventIsNotDisabled()
    }
    return <>
        {createForm()}
    </>

}

export default EventBlock;